import AjaxCommons from '@/services/ajax-commons';

export interface News {
    id: number;
    title: string;
    content: string;
    datum: number;
}

class NewsApiAgentImpl {
  constructor(private ajax = AjaxCommons) {}

  public getAll: () => Promise<News[]> = () => {
    return this.ajax.get('type=news');
  }

  public update = (id: string, title: string, content: string) => {
    return this.ajax.post(`type=news`, {
      id, title, content,
    }, 'put').then(result => {
      return !!(result && result.result);
    });
  }

  public add = (title: string, content: string) => {
    return this.ajax.post(`type=news`, {
      title, content,
    }, 'put');
  }

  public remove = (id: string) => {
    return this.ajax.post(`type=news`, {
      id,
    }, 'delete');
  }
}

const NewsApiAgent = new NewsApiAgentImpl();

export default NewsApiAgent;
export { NewsApiAgentImpl };
